import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Mail } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-b from-gray-900 to-black border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_hhh-craft-heat/artifacts/mmf9qjjm_logo.png"
                alt="HHHS Logo"
                className="w-16 h-16"
              />
              <div>
                <div className="text-2xl font-black text-white">HHHotsauce</div>
                <div className="text-sm text-orange-400">High Heat Hotsauce</div>
              </div>
            </div>
            <p className="text-gray-400 leading-relaxed max-w-sm">
              Small batch craft hot sauce with extreme heat and complex flavor. Limited edition batches that will never be reproduced.
            </p>
            <div className="flex gap-4 mt-4">
              <a 
                href="https://instagram.com/chemistry.dj"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-gradient-to-br from-red-600 to-orange-600 flex items-center justify-center hover:scale-110 transition-transform duration-300"
              >
                <Instagram className="w-5 h-5 text-white" />
              </a>
              <a 
                href="mailto:admin@hhhotsauce.org"
                className="w-10 h-10 rounded-full bg-gradient-to-br from-red-600 to-orange-600 flex items-center justify-center hover:scale-110 transition-transform duration-300"
              >
                <Mail className="w-5 h-5 text-white" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-orange-400 transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/shop" className="text-gray-400 hover:text-orange-400 transition-colors">
                  Shop
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-orange-400 transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-orange-400 transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-bold mb-4">Get in Touch</h3>
            <ul className="space-y-2 text-gray-400">
              <li>
                <a href="mailto:admin@hhhotsauce.org" className="hover:text-orange-400 transition-colors">
                  admin@hhhotsauce.org
                </a>
              </li>
              <li>
                <a href="https://instagram.com/chemistry.dj" target="_blank" rel="noopener noreferrer" className="hover:text-orange-400 transition-colors">
                  @chemistry.dj
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm">
            © {new Date().getFullYear()} HHHotsauce. All rights reserved.
          </p>
          <p className="text-gray-500 text-sm text-center">
            Heat with purpose. Flavor without compromise.
          </p>
        </div>

        {/* Age Disclaimer */}
        <div className="mt-6 text-center">
          <p className="text-xs text-gray-500">
            18+ Recommended. Extreme heat products. Use responsibly.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
